import React from "react";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

/**
 * Reference result body for Worli Matka (CasinoResult "worli"/"worli2"/"worli3" branch):
 *   .row.row5.worli-result > .col-12.col-lg-7 (the 3 drawn cards) + .col-12.col-lg-5
 *   (.casino-result-desc: "Pana:" desc[0], "Ocada:" desc[1], rdesc split on "#").
 */
export default function WorliResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5 worli-result">
      {cards.length ? (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <div className="casino-result-content-item text-center w-100">
              <div className="casino-result-cards">
                {[0, 1, 2].map((i) => (
                  <React.Fragment key={i}>
                    {i > 0 ? " " : null}
                    <div className="casino-result-cards-item">
                      <img src={`${IMG}/${cards[i]}.png`} alt="" />
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : null}{" "}
      <div className="col-12 col-lg-5">
        {desc.length ? (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Pana:</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Ocada:</div> <div>{desc[1]}</div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
